import styled from "styled-components";

export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing * 4}px;
  border-radius: ${({ theme }) => theme.radius}px;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing * 4}px;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.shades[0]};
  h1, p {
    margin: 0;
  }
  h1 {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.gray[900]};
  }
  p {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[700]}
  }
  &.background {
    background-color: ${({ theme }) => theme.colors.gray[100]};
  }
`;

export const IconContainer = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.gray[100]};
  > svg {
    > g, path {
      fill: ${({ theme }) => theme.colors.primary[300]};
    }
  }
`;
